import React, { useState, useEffect } from "react";
import { API_BASE } from "../utils/constants";

export default function BannerCarousel({ banners }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!banners.length) return;
    const t = setInterval(() => {
      setActive((prev) => (prev + 1) % banners.length);
    }, 4500);
    return () => clearInterval(t);
  }, [banners.length]);

  if (!banners.length) return null;

  return (
    <div className="banner-slider">
      {banners.map((b, i) => (
        <div
          key={b._id || b.id || i}
          className={`banner-slide ${i === active ? 'active' : ''}`}
          style={{ backgroundImage: `url(${b.image && b.image.startsWith("/") ? API_BASE + b.image : b.image})` }}
        />
      ))}
      {banners.length > 1 && (
        <div className="banner-dots">
          {banners.map((_, i) => (
            <div
              key={i}
              className={`banner-dot ${i === active ? 'active' : ''}`}
              onClick={() => setActive(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
